export enum Environment {
  local = 'local',
  dev = 'dev',
  preprod = 'preprod',
  prod = 'prod',
}
